import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function PhotographyTherapy() {
  const galleryItems = [{
    src: "https://dearexa.com/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-04-at-22.13.18.jpeg?v=3x6r85kyrwl",
    srcset: "https://dearexa.com/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-04-at-22.13.18.jpeg?v=mqogk624wrb-wvc-srcset",
    sizes: "https://dearexa.com/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-04-at-22.13.18.jpeg?v=bcdyjm43s9-wvc-sizes",
    alt: "即影即有影像整合創作",
    caption: "捕捉那些難以言喻的內心風景"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685908/img/photography_therapy_session.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685908/img/photography_therapy_session.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685908/img/photography_therapy_session.png-wvc-sizes",
    alt: "攝影治療過程",
    caption: "在快門之間重新觀看生命"
  }, {
    src: "https://dearexa.com/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-03-at-23.24.15-3.jpeg?v=gimtvk5tlni",
    srcset: "https://dearexa.com/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-03-at-23.24.15-3.jpeg?v=vl03ny9al8g-wvc-srcset",
    sizes: "https://dearexa.com/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-03-at-23.24.15-3.jpeg?v=0jka4kliryk6-wvc-sizes",
    alt: "影像與自我探索細節",
    caption: "引領你發現細碎與美好"
  }];
  return <section data-section-id="262844" id="影像與自我探索-photography-therapy" className="w-full text-foreground py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-start">
          {galleryItems.map((item, i) => <div key={i} data-index={i} className={`flex flex-col space-y-6 ${i === 1 ? "md:mt-20" : ""}`}>
              <figure className="group relative overflow-hidden rounded-lg">
                <div className="aspect-[3/4] overflow-hidden bg-secondary/20">
                  <img src={item.src} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} className="w-full h-full object-cover transition-all duration-1000 ease-in-out sepia-[0.2] saturate-[1.2] hue-rotate-[340deg] group-hover:scale-105 group-hover:opacity-90" loading="lazy" />
                  <div className="absolute inset-0 bg-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none" />
                </div>
                <figcaption className="mt-4 text-sm font-serif italic text-muted-foreground tracking-wide">
                  {item.caption}
                </figcaption>
              </figure>

              {i === 0 && <div className="pt-8 md:pt-12">
                  <span className="text-xs font-bold tracking-[0.2em] uppercase mb-4 block text-primary/60 font-sans">
                    PhotoTherapy
                  </span>
                  <h2 className="text-3xl md:text-4xl font-semibold font-serif leading-tight mb-6 text-foreground tracking-wide">
                    影像與自我探索
                  </h2>
                  <p className="text-base text-foreground/70 leading-relaxed font-default max-w-xs">
                    透過「影像整合創作模式」，讓即影即有的溫度，引領你重新觀看生命中的細碎與美好。
                  </p>
                </div>}

              {i === 2 && <div className="pt-8">
                  <Button asChild variant="outline" className="bg-transparent border-[hsl(10,70%,35%)] text-[hsl(10,70%,35%)] hover:bg-transparent hover:text-[hsl(10,70%,35%)] hover:opacity-70 transition-all duration-700 ease-in-out font-medium tracking-wider h-12 px-6 rounded-md border">
                    <Link to="/PhotographyTherapyPage">
                      探索 Explore
                      <ArrowRight className="ml-2 size-4" />
                    </Link>
                  </Button>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}